module.exports = __webpack_public_path__ + "assets/0387e5de9ab52b5f66badfbdd610397f.svg";